export default __webpack_public_path__ + "img/BB_RT.67e104a0b36d37cada80bbe5cc19184b.jpg";